import { render, staticRenderFns } from "./unitSelect2.vue?vue&type=template&id=008dccba"
import script from "./unitSelect2.vue?vue&type=script&lang=js"
export * from "./unitSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports